import React from 'react'
import { Grid } from '@material-ui/core'
import GestionRessourceProvider from '../GestionRessourceProvider'
import { getRessourceById, isRessourceHaveTache, updateRessource } from '../gestionRessourceApi'
import { colors, daysOfWeek } from '../../../../utils/constants'
import { useSnackbar } from '../../../../components/layout/snackbar/SnackbarContext'
import HeaderDetailRessource from './detailRessource/HeaderDetailRessource'
import FormRessource from './FormRessource'
import { formatTime, formValuesToCompetenceIds, getRessourceForInitValues } from '../utils/ressourceUtils'
import { DialogContext } from '../../../../components/layout/dialog'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import PopinTache from '../popin/PopinTache'
import { FormattedMessage } from 'react-intl'

const DetailRessourceOnglet = ({ match }) => {
	const { snackSuccess, snackError } = useSnackbar()
	const { openDialog } = React.useContext(DialogContext)
	const [ressource, setRessource] = React.useState({});
	const [checkingAffectations, setCheckingAffectations] = React.useState(false);
	const [refresh, setRefresh] = React.useState(false)

	React.useEffect(() => {
		getRessourceById(match.params.id)
			.then(setRessource)
	}, [refresh])

	const callUpdateRessource = (values) => {
		const { competences, ...otherValues } = values;
		updateRessource({
			competences: formValuesToCompetenceIds(values.competences),
			horaire: daysOfWeek.map(day => ({
				day,
				debut: values[`${day}Debut`] != null ? formatTime(values[`${day}Debut`]) : null,
				temps: values[`${day}Temps`]
			})),
			...otherValues
		})
			.then(() => {
				setRefresh(!refresh)
				snackSuccess({ id: 'gestionRessource.detailRessource.snackbar.success' })
			})
			.catch(() => {
				snackError({ id: 'gestionRessource.detailRessource.snackbar.error' })
			})
			.finally(() => setCheckingAffectations(false))
	}
	const onSubmit = (values) => {
		setCheckingAffectations(true)
		const { competences, ...otherValues } = values;

		daysOfWeek.forEach(day => {
			delete otherValues[`${day}Debut`];
		});

		// si on essaye de rendre une ressource inactive
		// todo : renommer en isInactive
		if (values.isActive) {
			isRessourceHaveTache(values.id).then(taches => {
				// on update que si on a pas de tâches affectées
				if (taches.length === 0) {
					callUpdateRessource(values)
				} else {
					setCheckingAffectations(false)
					openDialog(
						<Grid item container>
							<ErrorOutlineIcon style={{ color: colors.primary, marginRight: 10 }} />
							<FormattedMessage id="gestionRessource.detailRessource.inactive.title" />
						</Grid>,
						<PopinTache taches={taches} />,
						[]
					)
				}
			})
		} else {
			callUpdateRessource(values)
		}
	}

	return (
		<GestionRessourceProvider>
			<Grid style={{ padding: 50 }}>
				<HeaderDetailRessource />
				<FormRessource
					onSubmit={onSubmit}
					initialValues={getRessourceForInitValues(ressource)}
					checkingAffectations={checkingAffectations}
				/>
			</Grid>
		</GestionRessourceProvider>
	)

}

export default DetailRessourceOnglet